import FileSaver from "file-saver";
import { defineConfig } from "../config";
import { authHeader } from "../helpers";
import { utilsService } from "./utils";
const { handleResponse } = utilsService;

export const quoteService = {
  getQuoteById,
  getQuoteItemsByIdViewMode,
  getQuoteItemsByIdEditMode,
  getQuoteByStrategyId,
  upsertQuote,
  updateQuoteItemDiscount,
  approveQuote,
  generatePDF,
};

const { apiUrl } = defineConfig.QUOTE_SERVICE;

function getApiPath(){
  return (apiUrl);
}

function getQuoteById(id) {
  const url = `${getApiPath()}/${id}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getQuoteItemsByIdViewMode(id) {
  const url = `${getApiPath()}/${id}/view`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getQuoteItemsByIdEditMode(id, values = null) {
  const url = `${getApiPath()}/${id}/edit`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(values),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getQuoteByStrategyId(strategyId) {
  const url = `${ getApiPath()}/strategy/${strategyId}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function upsertQuote(strategyId = "", quoteId = "", values = null) {
  const url = `${getApiPath()}/upsert?strategyId=${strategyId}&quoteId=${quoteId}`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: values && JSON.stringify(values),
  };
  
  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function updateQuoteItemDiscount(id, discount) {
  const url = `${getApiPath()}/items/${id}/discount?discount=${discount}`;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
  };
  
  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function approveQuote(id) {
  const url = `${getApiPath()}/${id}/approve`;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function generatePDF(id, name) {
  const url = `${getApiPath()}/generate/pdf/${id}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
  .then(response => {
    return response.blob()
  })
  .then(function(blob) {
    FileSaver.saveAs(blob, name)
    return true;
  })
}